module.exports = __webpack_public_path__ + "img/transparent_document.9a349d4d.svg";